import DiamondTextBox from "../../componets/DiamondTextBox";
import Divider from "../../componets/Divider";
import servicesData from "../../data/projectOutsourcingServices.json";

export default function Section4() {
  return (
    <div className="Section4">
      <h2 className="md:w-[61%] mx-auto text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] my-[0.67em] text-center">
        Services We offer
      </h2>

      <DiamondTextBox data={servicesData} />

      <Divider />
    </div>
  );
}
